export default {
  loc: {
    'loading': 'Laden...',
    'start.step': 'Start',
    'start.button': 'start',
    'start.title': '<span>Mein</span> Kaffeegenerator',
    'start.description': 'Ihre eigene Kaffeeröstung in&nbsp;wenigen Schritten',
    'start.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'mod.step': 'Modus',
    'mod.barista.title': 'Barista',
    'mod.barista.description': 'Profi-modus<br>Kaffeemischung<br>konfigurieren',
    'mod.debutant.title': 'Debütant',
    'mod.debutant.description':
      'Beginner-modus<br>Schritt für schritt<br>anleitung',
    'mod.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'roastin.step': 'Röstgrad',
    'roastin.dunkel.subtitle': 'Röstungsgrad',
    'roastin.dunkel.title': 'dunkel',
    'roastin.dunkel.description': 'Dauer 8 – 12 min<br>bei 160 °C – 190 °C',
    'roastin.hell.subtitle': 'Röstungsgrad',
    'roastin.hell.title': 'hell',
    'roastin.hell.description': 'Dauer 8 – 25 min<br>bei 180 °C – 240 °C',
    'roastin.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'portion.step': 'Anteile',
    'portion.title': 'Zutaten & Anteile',
    'portion.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'acidity.step': 'Säure',
    'acidity.title': 'Säuregehalt',
    'acidity.description': 'Säurein Der Röstmischung<br>bestimmen',
    'acidity.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'aroma.step': 'Aromen',
    'aroma.title': 'Aromen',
    'aroma.description': 'und Noten zusammenstellen',
    'aroma.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'flavour.step': 'Geschmack',
    'flavour.title': 'Geschmack',
    'flavour.description': 'und Noten zusammenstellen',
    'flavour.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'aftertaste.step': 'Nachgeschmack',
    'aftertaste.title': 'Nachgeschmack',
    'aftertaste.description': 'und Noten zusammenstellen',
    'aftertaste.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'amount.step': 'Menge',
    'amount.title': 'Menge',
    'amount.description': 'Bestimmen sie hier die Röstmenge',
    'amount.count': '{0} Kg',
    '1kg': '1 Kg',
    '2kg': '2 Kg',
    '3kg': '3 Kg',
    '4kg': '4 Kg',
    '5kg': '5 Kg',
    '6kg': '6 Kg',
    '7kg': '7 Kg',
    '8kg': '8 Kg',
    '9kg': '9 Kg',
    '10kg': '10 Kg',
    '11kg': '11 Kg',
    '12kg': '12 Kg',
    '13kg': '13 Kg',
    '14kg': '14 Kg',
    '15kg': '15 Kg',
    '16kg': '16 Kg',
    '17kg': '17 Kg',
    '18kg': '18 Kg',
    '19kg': '19 Kg',
    '20kg': '20 Kg',
    'amount.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'label.step': 'Etikett',
    'label.title': 'Ihr Etikett',
    'label.description': 'bennen Sie ihre Kreation',
    'label.placeholder': 'Hier benennen',
    'label.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'summary.step': 'Resümee',
    'summary.title': 'Ihr Resümee',
    'summary.warning':
      'Bitte wählen Sie den gewünschten Säuregehalt, bevor Sie den nächsten Schritt machen.',

    'roundtext.progress': 'Progress',
    'roundtext.ingredients': 'Zutaten',
  },
};
